import { PatternFormat } from 'react-number-format';
import TextInput from './textInput';
import moment from 'moment';

function DateInput(props:any) {

	const {
		id,
		name,
		value,
		type,
		className,
		validate = (value: string) => !(value && value.length),
		onChange,
		...rest
	}:{
		id: any,
		name: string,
		value: string,
		type: 'text' | 'tel' | 'password',
		className: any,
		validate?: Function,
		onChange: Function,
	} = props

	const handleChange = (values:any) => {
		const { formattedValue } = values;

		var error = false;

		var date = moment(formattedValue, 'MM/DD/YYYY', true);
		if (!date.isValid() || (date.year() <= 1900 || date.year() >= 2100)) {
			error = true;
		} else {
			error = validate(formattedValue)
		}

		return onChange({ target: { name, value: formattedValue } }, error)
	};

	return (
		<PatternFormat format="##/##/####" customInput={TextInput} id={id} name={name} type={type} onValueChange={handleChange} value={value} mask="_" className={className} {...rest} />
	);
}

export default DateInput
